//
// Orientation booleans
//
// Default for dir is `horizontal` so we can set booleans accordingly
// if the value present is the only other option.
//
export const containerOrientations = (dir) => {
    return {
        horizontal: dir !== 'vertical',
        vertical: dir === 'vertical',
    };
};
